import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
  CircularProgress
} from '@mui/material';
import {
  Warning as WarningIcon,
  Save as SaveIcon,
  ExitToApp as ExitIcon
} from '@mui/icons-material';

function UnsavedChangesModal({
  open,
  onSaveAndNavigate,
  onNavigateWithoutSaving,
  onCancel,
  saving = false
}) {
  return (
    <Dialog 
      open={open} 
      onClose={saving ? undefined : onCancel} 
      maxWidth="sm" 
      fullWidth
      disableEscapeKeyDown={saving}
    >
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <WarningIcon color="warning" />
          Unsaved Changes
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          You have unsaved changes that will be lost if you navigate away. 
          Would you like to save your changes before continuing?
        </Typography>
        {saving && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 2 }}>
            <CircularProgress size={16} />
            <Typography variant="body2" color="text.secondary">
              Saving changes...
            </Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={saving}>
          Cancel
        </Button>
        <Button
          onClick={onNavigateWithoutSaving}
          color="error"
          variant="outlined"
          startIcon={<ExitIcon />}
          disabled={saving}
        >
          Leave Without Saving
        </Button>
        <Button
          onClick={onSaveAndNavigate}
          color="primary"
          variant="contained"
          startIcon={saving ? <CircularProgress size={16} /> : <SaveIcon />}
          disabled={saving}
        >
          {saving ? 'Saving...' : 'Save & Continue'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default UnsavedChangesModal;